var render = function render(){var _vm=this,_c=_vm._self._c;return _c('my-talent',{attrs:{"focus":2,"sourcePage":"emphasisTalent"}})
}
var staticRenderFns = []

export { render, staticRenderFns }